import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Plane, Train, Car, Ship, Bus, HelpCircle, Sparkles } from "lucide-react";

const MODE_ICONS = { Avion: Plane, Train: Train, Route: Car, Bateau: Ship, Bus: Bus, Autre: HelpCircle };

export default function PublicFeed() {
  const [trips, setTrips] = useState([]);
  useEffect(() => {
    api.get("/trips/public/recent?limit=8").then(r => setTrips(r.data)).catch(()=>{});
    const t = setInterval(() => { api.get("/trips/public/recent?limit=8").then(r => setTrips(r.data)).catch(()=>{}); }, 20000);
    return () => clearInterval(t);
  }, []);
  if (!trips.length) return null;
  return (
    <section className="max-w-6xl mx-auto px-4 py-16">
      <div className="flex items-end justify-between mb-6">
        <h2 className="font-display text-3xl md:text-4xl font-bold">Trajets à saisir</h2>
        <Link to="/search" className="text-sm text-[#FF6B6B] hover:underline">Voir tout →</Link>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-3">
        {trips.map(t => {
          const Ic = MODE_ICONS[t.mode] || HelpCircle;
          return (
            <Link data-testid={`public-trip-${t.trip_id}`} to={`/search?origin=${encodeURIComponent(t.origin.label)}&destination=${encodeURIComponent(t.destination.label)}`} key={t.trip_id}
              className="glass rounded-xl p-4 hover:border-slate-500 border border-slate-800 transition group">
              <div className="flex items-center gap-2 mb-2 text-xs text-slate-400">
                <span className="w-8 h-8 rounded-lg bg-slate-800 flex items-center justify-center"><Ic size={14} className="text-[#F59E0B]"/></span>
                {t.mode} · {new Date(t.depart_at).toLocaleDateString("fr-FR")}
              </div>
              <div className="font-semibold text-sm text-slate-100 leading-snug">{t.origin.label}<br/><span className="text-slate-500">→ {t.destination.label}</span></div>
              <div className="mt-2 text-[10px] text-slate-500 flex items-center gap-1">
                <Sparkles size={10} className="text-[#F59E0B] group-hover:animate-pulse"/> par {t.traveler?.name}
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
